module.exports = __webpack_public_path__ + "static/img/icon_xuancheng_shuzi_liaofa.01816f34.png";